module.exports = __webpack_public_path__ + "img/fourthCustom.8240268a.svg";